import { render } from "./vertical-steps.vue?vue&type=template&id=bc517c5c"
import script from "./vertical-steps.vue?vue&type=script&lang=js"
export * from "./vertical-steps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__